import { Outlet } from 'react-router-dom';
import NotFound from '../routes/NotFound';
import { isParticipantDeviceEnabled } from '../lib/participantDeviceCookie';

/**
 * Layout route: pagine gara visibili solo con cookie `participantEnabled`.
 * Senza cookie → 404 (nessun redirect verso `/enable-device`).
 */
export default function CompetitionDeviceGate() {
  if (isParticipantDeviceEnabled()) {
    return <Outlet />;
  }
  return <NotFound />;
}
